import React from "react";
import SpeechToText from "./SpeechToText";

const SpeechToTextTranslation = () => {
  return <SpeechToText />;
};

export default SpeechToTextTranslation;
